import React from 'react';

import TitlePages from 'components/_base/TitlePages';
import Contact from 'components/Contact';
import OpenCalled from 'components/OpenCalled';
import Doubts from 'components/Doubts';

import './styles.scss';

const ContentAttendance = () => {
  return (
    <div className="wrapper-atendimento">
      <TitlePages title="ATENDIMENTO" />
      <div className="content">
        <div className="contato col-lg-10">
          <Contact />
        </div>
        <div className=" abrirChamado col-lg-10">
          <OpenCalled />
        </div>
        <div className=" duvidas col-lg-10">
          <Doubts />
        </div>
      </div>
    </div>
  );
};

export default ContentAttendance;
